import type { IRhizomPageProps } from "@/types/RhizomPageProps/RhizomPageProps";
import { usePage } from "@inertiajs/vue3";
import { computed, ref } from "vue";

export default () => {
    const inertiaProps = usePage<IRhizomPageProps>();

    const hasTeamMemberAccess = computed(() => {
        // Admin users and God mode users have access to all features regardless of subscription
        if (inertiaProps.props.isAdmin || inertiaProps.props.hasGodMode) {
            return true;
        }

        return inertiaProps.props.isTrialing || inertiaProps.props.isSubscribed;
    });

    const showUpgradeModal = ref(false);

    const checkAccessOrShowModal = () => {
        if (!hasTeamMemberAccess.value) {
            showUpgradeModal.value = true;
            return false;
        }
        return true;
    };

    const closeUpgradeModal = () => {
        showUpgradeModal.value = false;
    };

    return {
        hasTeamMemberAccess,
        showUpgradeModal,
        checkAccessOrShowModal,
        closeUpgradeModal,
    };
};
